import { useGeo } from '@telescope/cassini-hooks';
import { Container, Spinner } from '@telescope/cassini-ui';
import React from 'react';
import { Navigate } from 'react-router-dom';

type GeoFilterClusivity = 'inclusive' | 'exclusive';

interface GeoBlockingProps {
  countries: string[];
  listType: GeoFilterClusivity;
  allowAprUsers: boolean;
  children: React.ReactNode;
}
export const GeoBlocking = ({ countries, listType, allowAprUsers, children }: GeoBlockingProps) => {
  const { inRegion, isLoading, aprAllowed } = useGeo(countries, {
    listType,
    allowAprUsers,
  });

  if (isLoading) {
    return (
      <Container centerContent>
        <Spinner label="Loading..." />
      </Container>
    );
  }

  if (!inRegion) {
    return <Navigate to="/error/geo" />;
  }

  if (!aprAllowed) {
    return <Navigate to="/error/apr" />;
  }

  return <>{children}</>;
};
